import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { trackPDPReviewClick } from 'utils/tracking';

const Reviews = ({ id }) => {
  const yotpoRef = useRef(null);
  const technicalDataEl = document.querySelector('[data-technical]');
  const data = JSON.parse(technicalDataEl.textContent);
  const instanceId = data.yotpoBottomlineId;

  useEffect(() => {
    if (window.yotpoWidgetsContainer?.initWidgets) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, [id]);

  useEffect(() => {
    if (yotpoRef.current) {
      yotpoRef.current.addEventListener('click', (e) => {
        if (e.target.classList.contains('yotpo-sr-bottom-line-new-review')) {
          trackPDPReviewClick('top');
        }
      });
    }
  }, [yotpoRef.current]);

  return (
    <div
      ref={yotpoRef}
      className={`yotpo-widget-instance ${window.yotpoWidgetsContainer?.initWidgets ? "h-[29px] mb-2.5 mt-2" : ""}`}
      data-yotpo-instance-id={instanceId}
      data-yotpo-product-id={id}
      data-yotpo-cart-product-id={id}
      data-yotpo-section-id="product"
    ></div>
  );
};

export default Reviews;
